export default __webpack_public_path__ + "static/media/logo.b73732eb.png";